<template>
    <v-alert
        color="warning"
        :icon="mdiAlert"
    >
        <p class="mt-0">
            The email address you entered does not exist in our system. Please make sure you spelled the email address correctly.
            If you continue to have issues, please contact <CustomerServiceQuickLink>customer service</CustomerServiceQuickLink> for assistance.
        </p>
        <p class="mb-0">
            If you'd like to create a new account, <NuxtLink to="/create-account">click here</NuxtLink>.
        </p>
    </v-alert>
</template>

<script lang="ts" setup>
    import CustomerServiceQuickLink from '~/components/support/CustomerServiceQuickLink/CustomerServiceQuickLink.vue';
    import { mdiAlert } from '@mdi/js';
</script>

<style lang="scss"></style>
